import React, { useState, useEffect, useContext } from "react";
import SocketContext from "../../contexts/SocketContext";
// import { useSocket } from "../../contexts/SocketContextG";
import useLogout from "../../hooks/useLogout";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

import "./TopNav.css";

const TopNav = () => {
  //Import socket from context
  const { socket } = useContext(SocketContext);
  // const { socket } = useSocket();

  //Socket status state
  const [isConnected, setIsConnected] = useState(socket.connected);

  // Socket Connection and onLoad Queries
  useEffect(() => {
    const onConnect = () => {
      setIsConnected(true);
    };
    const onDisconnect = () => {
      setIsConnected(false);
    };
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, []);

  // useLogout
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    socket.disconnect();
  };

  return (
    <div className='topNav'>
      <FontAwesomeIcon className={isConnected ? "online" : "offline"} icon={faCircle} />
      <div>{isConnected ? "online" : "offline"}</div>
      <button
        onClick={() => {
          signOut();
        }}
      >
        Log Out
      </button>
    </div>
  );
};

export default TopNav;
